import Vue from 'vue'
import App from './App.vue'
import router from "./router/index"
Vue.config.productionTip = false
import store from './store'
import axios from 'axios'
Vue.prototype.axios = axios

import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Toast } from 'vant'
Vue.use(Toast)

import moment from "moment"
Vue.prototype.$moment = moment

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(echarts)

Vue.prototype.$redirectToLogin1 = function () {
  app.$router.push({ path: '/login?id=-8' })
}

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)
import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
    debug: false,
    connection: 'https://ws.xingkeele.com/?token=80072afd-84dc-4ccc-845a-a25c9786bf60',
    options: {
        autoConnect: false,
        // path: "",
        // transports: ['websocket'],
    }
}))
import wx from 'weixin-js-sdk'
Vue.prototype.wx = wx
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// iOS 微信 JSSDK 签名校验用"首次进入的 URL"，且 SPA/pushState 改写地址后无法还原；
// 在应用启动最早期（任何路由跳转/pushState 之前）记录首次进入的 URL（去掉 hash），供 JSSDK 签名使用
// 注意：不能用 localStorage —— login.vue 的 created() 会 localStorage.clear() 把它清掉；
// window.name 在整个 SPA 生命周期（含路由跳转、localStorage 清空）中始终保留
// 带 ?key= 的是登录入口（含切换账号整页重载），必须用新 URL 覆盖，
// 否则安卓切换账号后签名仍用旧 URL，与微信按"当前 URL"校验不一致导致扫码失效
if (location.href.indexOf('?key=') > -1 || !window.name || window.name.indexOf('wx_sign_url=') !== 0) {
  window.name = 'wx_sign_url=' + location.href.split('#')[0]
}

const app = new Vue({
  router,
  store: store,
  render: h => h(App),
}).$mount('#app')